import { Component, OnDestroy, OnInit } from '@angular/core'
import { FuseTranslationLoaderService } from '../../../../core/services/translation-loader.service'
import { dutchDocument } from '../i18n/nl'
import { DocumentResponse } from '../../../models/document-response'
import { ActivatedRoute, Event, Router } from '@angular/router'
import { FormControl } from '@angular/forms'
import { MatTableDataSource, PageEvent } from '@angular/material'
import { DocumentModel } from '../../../models/document.model'
import { Subscription } from 'rxjs/Subscription'
import { DocumentsService } from '../../../services/documents.service'
import 'rxjs/add/operator/debounceTime'
import 'rxjs/add/operator/distinctUntilChanged'
import 'rxjs/add/operator/do'
import { AdministrationModel } from '../../../models/administration.model'

@Component({
  selector: 'app-document-list',
  templateUrl: './document-list.component.html',
  styleUrls: ['./document-list.component.scss'],
})
export class DocumentListComponent implements OnInit, OnDestroy {
  searchChanged: Subscription
  documentsChanged: Subscription
  documentResponse: DocumentResponse
  searchInput: FormControl
  displayedColumns = ['name', 'status', 'lyantheStatus', 'created']
  dataSource: any
  isLoading = false

  pageIndex: number
  limit: number

  constructor(
    private _translationLoader: FuseTranslationLoaderService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _documentService: DocumentsService,
  ) {
    this.searchInput = new FormControl('')
    this._translationLoader.loadTranslations(dutchDocument)
  }

  ngOnInit() {
    // this.documentResponse = this._route.snapshot.data.documentResponse;

    this.searchChanged = this.searchInput.valueChanges
      .debounceTime(400)
      .distinctUntilChanged()
      .do(searchText => {
        this._documentService.filter('search', searchText)
      })
      .subscribe()

    this.documentsChanged = this._documentService.documentsChanged
      .filter(documentResponse => !!documentResponse)
      .subscribe((response: DocumentResponse) => {
        this.isLoading = false
        this.documentResponse = response
        this.mapDocumentResponse(this.documentResponse)
      })
    this.mapDocumentResponse(this.documentResponse)
  }

  ngOnDestroy() {
    this.documentsChanged.unsubscribe()
    this.searchChanged.unsubscribe()
  }

  mapDocumentResponse(administrationResponse: DocumentResponse) {
    this.isLoading = false
    const adminArray = []
    for (const document of administrationResponse.rows) {
      adminArray.push(new DocumentModel(document))
    }
    this.dataSource = new MatTableDataSource<AdministrationModel>(adminArray)
    this.limit = administrationResponse.pagination.limit
    this.pageIndex = administrationResponse.pagination.current_page - 1
  }

  pagination(event?: PageEvent) {
    const page = {
      page: event.pageIndex,
      limit: event.pageSize,
    }
    this._documentService.mergeFilters(page)
  }
  /**
   *
   * @param {DocumentModel} document
   */
  readDocument(document: DocumentModel) {
    this._router.navigate(['/documents/' + document.id])
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/documents/document-list/document-list.component.ts